import { Container, Card, Typography } from "@mui/material"

import AuditTable from "../../components/audits/AuditTable";

/**
 * The actual auditing dashboard page.
 */
function AuditingDashboard() {

    return (
        <Container maxWidth={"xl"}>
            <Typography variant="h3" gutterBottom>Audit Log</Typography>
            <Card>
                <AuditTable/>
            </Card>
        </Container>
    )
}

export default AuditingDashboard